import React from 'react'
import Link from 'gatsby-link'

import CookieBanner, { BannerContent, cookie } from 'react-cookie-banner'

class Cbanner extends React.Component {

	state = {
    dismissOnScroll: false
  }

  resetCookies = () => {
    cookie('accepts-cookies', '');
    this.refresh();
  }

  toggleDismissOnScroll = () => {
    this.setState({ dismissOnScroll: !this.state.dismissOnScroll });
  }

  refresh = () => {
    this.setState({});
  }

  render() {

		const {
	refresh, toggleDismissOnScroll, resetCookies,
	state: { dismissOnScroll }
} = this;

const cookieProps = {
	dismissOnScroll,
	onAccept: refresh
};

const bannerContentProps = {
	styles: { button: { color: 'blue' } },
	message: 'This website uses cookies. By continuing to use the website, you agree to the use of cookies. For more information about cookies, please refer to the',
	link: { msg: 'Privacy Policy', url: '/privacy', target: '_self' },
	buttonMessage: 'Got it!'
};

    return (
			<div style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', zIndex: 999 }}>

        <CookieBanner
					{...cookieProps}
					styles={{
						banner: {
							height: 57,
							backgroundSize: '30px 30px',
							backgroundColor: 'rgba(52, 64, 81, 0.88)',
							fontSize: '12px',
							fontWeight: 600
						},
						button: {
							border: '1px solid white',
							borderRadius: 4,
							width: 66,
							height: 32,
							lineHeight: '32px',
							background: 'transparent',
							color: 'white',
							fontSize: '14px',
							fontWeight: 600,
							opacity: 1,
							right: 20,
							marginTop: -18
						},
						message: {
							display: 'block',
							padding: '9px 67px',
							lineHeight: 1.3,
							textAlign: 'center',
							color: 'white',
							marginLeft: '20px',
							marginRight: '20px',
						},
						link: {
							textDecoration: 'none',
							fontWeight: 'bold'
						}
					}}
					>
          {(onAccept) => (
            <div onClick={onAccept}>
              <BannerContent {...bannerContentProps} onAccept={onAccept} />
            </div>
          )}
        </CookieBanner>

      </div>
    );
  }

}

export default Cbanner



// WEBPACK FOOTER //
// ./src/components/cookieInfo/index.jsx